<template>
  <v-layout row wrap fill-height>
    <v-flex xs12>
      <v-toolbar dense dark color="blue accent-3" class="elevation-0">
        <v-toolbar-title class="mt-3">Nastavení</v-toolbar-title>
        <v-tabs v-model="activeTab" color="transparent" slot="extension" class="mlm10">
          <v-tab :key="1" ripple>
            Uživatelé
          </v-tab>
          <v-tab :key="2" ripple>
            Číselníky
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <div class="pl-2 pr-3">
        <v-card>
          <v-card-text class="pa-0">
            <v-tabs-items v-model="activeTab">
              <v-tab-item :key="1">
                <Uzivatele></Uzivatele>
              </v-tab-item>
              <v-tab-item :key="2">
                <Ciselniky></Ciselniky>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

import Ciselniky from '@/pages/Nastaveni/Ciselniky'
import Uzivatele from '@/pages/Nastaveni/Uzivatele'

export default {
  data () {
    return {
      activeTab: 1,
      tabs: [ "uzivatele", "ciselniky" ],
      loading: true
    };
  },
  props: {
    tab: String
  },
  watch: {
    activeTab (val) {
      if (!this.loading)
        this.$router.replace({ path: "/nastaveni/"+this.tabs[val] })
    }
  },
  mounted: function() {
    window.MenuListener.hide();
    if (this.$props.tab != null && this.tabs.indexOf(this.$props.tab) >= 0)
      this.activeTab = this.tabs.indexOf(this.$props.tab);
    this.loading = false;
  },
  components: {
    Ciselniky, Uzivatele
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Nastaveni/Nastaveni.vue